module.exports = __webpack_public_path__ + "static/phone-8567b0ce7e71a6ce21b43746fc53f9f7.jpg";